import axios from './axios';

export const getClientByEmailHash = (emailHash) => axios.get('/autocare/' + emailHash);
export const getAutocareToken = (autocareEmailHash) => axios.get(`/auth/public/${autocareEmailHash}`);



// WEBPACK FOOTER //
// ./src/requesters/autocare.js